var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tabs',{staticClass:"tabs_vertical",attrs:{"vertical":"","expanded":"","animated":false},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }